import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useForm, useFieldArray} from 'react-hook-form';
import Button from '../../../components/button/button';
import XCloseIcon from '../../../assets/icons0/x-close.svg';
import classNames from 'classnames';

const PollForm = React.memo(({register, formState, control, onRemove}) => {
    const {fields, append, remove} = useFieldArray({
        control,
        name: 'pollOptions',
        rules: {minLength: 2}
    });

    const addOption = React.useCallback(() => {
        if (fields.length < 10) {
            append({value: ''});
        }
    }, [append, fields.length]);

    const removeOption = React.useCallback((index) => {
        if (fields.length > 2) {
            remove(index);
        }
    }, [remove, fields.length]);

    return (
        <div className='margin-top-1rem padding-1dot25rem border-radius-0dot75rem border-style-solid border-width-0dot0625rem border-color-gray-200'>
            <div className='display-flex align-items-center justify-content-space-between padding-bottom-1rem'>
                <div className='text-md semibold color-gray-900'>
                    <FormattedMessage defaultMessage='Poll' />
                </div>
                <button
                    type='button'
                    onClick={onRemove}
                    className='text-sm color-error-600 hover-color-error-700 cursor-pointer background-color-transparent border-style-none padding-0'
                >
                    <FormattedMessage defaultMessage='Remove poll' />
                </button>
            </div>
            <div className='display-flex flex-direction-column row-gap-0dot75rem'>
                {fields.map((field, index) => (
                    <div key={field.id} className='display-flex flex-direction-column row-gap-0dot25rem'>
                        <div className='display-flex align-items-center column-gap-0dot5rem'>
                            <div className='flex-1'>
                                <input
                                    type='text'
                                    {...register(`pollOptions.${index}.value`, {
                                        required: 'Option is required',
                                        maxLength: {
                                            value: 100,
                                            message: 'Option cannot exceed 100 characters'
                                        }
                                    })}
                                    defaultValue={field.value}
                                    className={classNames('width-100percent padding-0dot75rem border-style-solid border-width-0dot0625rem border-radius-0dot5rem text-md color-gray-900', {
                                        'border-color-error-500': formState?.errors?.pollOptions && formState.errors.pollOptions[index]?.value,
                                        'border-color-gray-300': !formState?.errors?.pollOptions || !formState.errors.pollOptions[index]?.value
                                    })}
                                    placeholder={`Option ${index + 1}`}
                                    maxLength={100}
                                />
                            </div>
                            {fields.length > 2 && (
                                <Button
                                    type='button'
                                    size='sm'
                                    color='error'
                                    plain={true}
                                    clickHandler={() => removeOption(index)}
                                    additionalClasses='btn---icon-plain-square flex-shrink-0'
                                >
                                    <XCloseIcon className='display-block width-1dot25rem height-1dot25rem'/>
                                </Button>
                            )}
                        </div>
                        {formState?.errors?.pollOptions && formState.errors.pollOptions[index]?.value && (
                            <p className='text-sm color-error-600'>
                                {formState.errors.pollOptions[index].value.message}
                            </p>
                        )}
                    </div>
                ))}
            </div>
            {fields.length < 10 && (
                <div className='padding-top-1rem'>
                    <Button
                        type='button'
                        size='md'
                        color='primary'
                        plain={true}
                        clickHandler={addOption}
                    >
                        <FormattedMessage defaultMessage='Add option' />
                    </Button>
                </div>
            )}
        </div>
    );
});

export default PollForm;

